var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCardFormalize = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 3.71H2.625C1.57 3.71.75 4.57.75 5.587v13.75c0 1.055.82 1.875 1.875 1.875h18.75c1.016 0 1.875-.82 1.875-1.875V5.586c0-1.016-.86-1.875-1.875-1.875ZM22 19.337a.642.642 0 0 1-.625.625H2.625A.617.617 0 0 1 2 19.336V5.586c0-.313.273-.625.625-.625h18.75c.313 0 .625.312.625.625v13.75ZM8.25 16.68a.504.504 0 0 0-.469-.47H4.97a.475.475 0 0 0-.469.47v.312c0 .274.195.469.469.469H7.78a.475.475 0 0 0 .469-.469v-.312Zm7.5 0a.504.504 0 0 0-.469-.47H9.97a.475.475 0 0 0-.469.47v.312c0 .274.195.469.469.469h5.312a.475.475 0 0 0 .469-.469v-.312Z",
    fill: "#9496AC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCardFormalize);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/card-formalize.d2c73bc614d3de783541a46dc7eaec27.svg";